import {
  CHAMBER_BED_MOVED,
  CHAMBER_BED_TRANSFORMED,
  CHAMBER_SET_CENTRALICED_COORDINATES,
  CHAMBER_BED_CHAMBER_ROWS_REBUILD,
  CHAMBER_ROW_SET_OFFSET,
  CHAMBER_ACTIVATE,
  CHAMBER_DEACTIVATE,
  CHAMBER_SET_SELECTED,
  CHAMBER_RESET_SELECTED,
  DRAWINGTOOLBAR_CHANBERS_AUTOFILL,
  DRAWINGTOOLBAR_CHANBERS_AUTOEMTPY,
  DRAWINGTOOLBAR_ENDCAPS_AUTOADD,
  CHAMBER_ADD_LEFT,
  CHAMBER_ADD_TOP,
  CHAMBER_ADD_RIGHT,
  CHAMBER_ADD_DOWN,
  CHAMBER_ADD_ROW,
  CHAMBER_REMOVE_LEFT,
  CHAMBER_REMOVE_TOP,
  CHAMBER_REMOVE_RIGHT,
  CHAMBER_REMOVE_DOWN,
  CHAMBER_REMOVE_ROW,
  CHAMBER_SET_ACCESORY,
  CHAMBER_SET_UPPER_CAP_ACCESORY,
  CHAMBER_SET_LOWER_CAP_ACCESORY,
  APPTOOLBAR_RESET_APP_STATE,
  CALCULATIONS_VOLUME_OPTIMIZED,
  PROJECTS_CRUD_RESTORE_STATE,
  INLET_MANIFOLD_ID,
  CHAMBER_BED_CLEAN,
  CHAMBERS_DEACTIVATE,
  CHAMBERS_ACTIVATE,
  CHAMBERS_META_UPDATE,
  CHAMBERS_META_CLEAN,
  CHAMBERS_ISOLATOR_UPDATE,
  CHAMBERS_ISOLATOR_CLEAN,
  CHAMBER_SET_KEY_VALUE,
  CHAMBERS_MANIFOLD_VOID_CLEAN,
  CHAMBERS_MANIFOLD_META_UPDATE,
  CHAMBERS_MANIFOLD_MAIN_ROW_CLEAN,
  SUB_PROJECTS_CRUD_RESTORE_STATE,
  MULTIBED_RESET_APP_STATE,
  APPTOOLBAR_BASIC_RESET_APP_STATE,
  SHOW_INSERTA_TEE_WARNING,
  SHOW_INSERTA_TEE_VALUES,
  SHOW_INSERTA_TEE_WARNING_TYPE,
  IMPERVIOUS_LINER,
  SHOW_FEED_CONNECTOR_VALUES,
  NUMBER_OF_FEED_CONNECTORS,
  POSITION_OF_INSPECTION_PORT
} from "../lib/types";

import ChamberRowClass from "../lib/chamber-row";
import chamberClass from "../lib/chamber";
import { getRequiredChamberSlotsForTwoEndcaps } from "../lib/chamberBed/utils";
import ChamberRowService from "../lib/services/chamber-row-service";
import { createSelector } from "reselect";
import ManifoldSelectors from "./main-manifold-reducer";

/* Resolved lazily: store.js -> reducers/index.js -> this module, so a top-level
   store import leaves that cycle half-initialised depending on entry point. */
const getStore = () => require("../store").default;

const LEFT = "LEFT";
const UP = "UP";
const RIGHT = "RIGHT";
const DOWN = "DOWN";
const DEFAULT_NUM_OF_ROWS = 5;
const DEFAULT_NUM_OF_CHAMBERS = 9;
const initialState = {
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1,
  rotation: 180,
  height: 178,
  width: 389.4,
  visible: true,
  chamberRows: [],
  hasCornerOutlet: true,
  numOfRows: DEFAULT_NUM_OF_ROWS,
  numOfChambers: DEFAULT_NUM_OF_CHAMBERS,
  selectedChamberRow: -1,
  selectedChamberCol: -1,
  lockedRows: false,
  isDirty: null,
  insertaTeeWarning: false,
  insertaTeeWarningType: "",
  insertaTeeValues: {
    col: 0,
    row: 0,
    chamberAccessory: {}
  },
  feedConnectorValues: {
    col: 0,
    row: 0,
    chamberAccessory: {}
  },
  imperviousLiner: false,
  feedConnectors: {
    numberOfFeedConnectors: 0,
    numberOfRemovedFeedConnectors: 0
  },
  positionOfInspectionPort: {row:0, col:0}
};

function updateChamberRow(
  rowKeyValues,
  chambersKeyValues,
  state,
  row,
  col,
  autofill,
  autoEmpty
) {

  return state
    .chamberRows
    .slice()
    .map(( chamberRow, i ) => {
      let newChamberRow = chamberRow.clone();
      if (row === i) {
        newChamberRow.modifyChamber(chambersKeyValues, col);
        Object.assign(newChamberRow, rowKeyValues);

        newChamberRow.autoAddEndcaps(
          getRequiredChamberSlotsForTwoEndcaps(
            newChamberRow.endCapWidth,
            newChamberRow.chamberWidth
          ));

        const thisChamber = newChamberRow.chambers[col];
        if (thisChamber && typeof chambersKeyValues.accessory === "undefined") {
          const manifoldIds = newChamberRow.chambers.filter(c =>
            ( c.upperCapAccessory && c.upperCapAccessory.id === INLET_MANIFOLD_ID && c.upperCapAccessory.manifoldId ) ||
            ( c.lowerCapAccessory && c.lowerCapAccessory.id === INLET_MANIFOLD_ID && c.lowerCapAccessory.manifoldId )
          ).map(c => {
            return {
              manifoldId: c.upperCapAccessory && c.upperCapAccessory.manifoldId
                ? c.upperCapAccessory.manifoldId
                : c.lowerCapAccessory.manifoldId,
              col: c.col
            };
          });

          manifoldIds.forEach(mId => {
            const manifoldId = mId.manifoldId;
            const mIdNdx = thisChamber.isIsolatorArray.indexOf(manifoldId);
            if (!thisChamber.active) {
              if (mIdNdx > -1) {
                newChamberRow.resetChambersIsolatorArray(manifoldId, col);
                const increment = mId.col < col ? 1 : -1;
                let nextChamber = newChamberRow.chambers[col + increment];
                while (nextChamber) {
                  if (nextChamber.isIsolatorArray.find(isoArrEntry => isoArrEntry === manifoldId)) {
                    let newChamber = newChamberRow.resetChambersIsolatorArray(manifoldId, nextChamber.col);
                    newChamberRow.modifyChamber(newChamber, nextChamber.col);
                  }
                  nextChamber = newChamberRow.chambers[nextChamber.col + increment];
                }
              }
            } else if (mIdNdx === -1) {
              if (ChamberRowService.isUnbrokenInBetween(newChamberRow, col, mId.col)
                && newChamberRow.chambers[mId.col].isIsolatorArray.indexOf(manifoldId) > -1) {
                newChamberRow.modifyChamberIsolatorMeta({ isIsolatorArray: { manifoldId: manifoldId } }, col);
                let increment = mId.col < col ? -1 : 1;
                let nextChamber = newChamberRow.chambers[col + increment];
                while (nextChamber && nextChamber.active) {
                  if (!nextChamber.isIsolatorArray.find(isoArrEntry => isoArrEntry === manifoldId)) {
                    newChamberRow.modifyChamberIsolatorMeta({ isIsolatorArray: { manifoldId: manifoldId } }, nextChamber.col);
                  }
                  nextChamber = newChamberRow.chambers[nextChamber.col + increment];
                }
                // switch direction and work backwards in case we're joining iso & non-iso together in the row
                increment *= -1;
                nextChamber = newChamberRow.chambers[col + increment];
                while (nextChamber && nextChamber.active) {
                  if (!nextChamber.isIsolatorArray.find(isoArrEntry => isoArrEntry === manifoldId)) {
                    newChamberRow.modifyChamberIsolatorMeta({ isIsolatorArray: { manifoldId: manifoldId } }, nextChamber.col);
                  }
                  nextChamber = newChamberRow.chambers[nextChamber.col + increment];
                }
              }
            }
          });
        }
      } else if (autofill) {
        newChamberRow.autoSwitch(true);
        const requiredSlots = getRequiredChamberSlotsForTwoEndcaps(
          newChamberRow.endCapWidth,
          newChamberRow.chamberWidth
        );
        newChamberRow.autoAddEndcaps(requiredSlots);
        const manifoldIds = newChamberRow.chambers.filter(c =>
          ( c._col === newChamberRow.chambers[0]._col || c._col === newChamberRow.chambers[newChamberRow.chambers.length - 1]._col ) &&
          ( ( ( c.upperCapAccessory && c.upperCapAccessory.id === INLET_MANIFOLD_ID && c.upperCapAccessory.manifoldId )
              && ( c.isIsolatorArray.find(isoArrEntry => isoArrEntry === c.upperCapAccessory.manifoldId) ) ) ||
            ( ( c.lowerCapAccessory && c.lowerCapAccessory.id === INLET_MANIFOLD_ID && c.lowerCapAccessory.manifoldId )
              && ( c.isIsolatorArray.find(isoArrEntry => isoArrEntry === c.lowerCapAccessory.manifoldId) ) ) )
        ).map(c => {
          return {
            manifoldId: c.upperCapAccessory && c.upperCapAccessory.manifoldId
              ? c.upperCapAccessory.manifoldId
              : c.lowerCapAccessory.manifoldId
          };
        });
        if (manifoldIds && manifoldIds.length) {
          for (let i = 0; i <= newChamberRow.chambers.length; i++) {
            newChamberRow.modifyChamberIsolatorMeta({ isIsolatorArray: { manifoldId: manifoldIds[0].manifoldId } }, i);
          }
        }
      } else if (autoEmpty) {
        newChamberRow.autoSwitch(false);
        newChamberRow.autoRemoveEndcaps();
      }
      return newChamberRow;
    });
}


/**
 * Will update the chambers on corresponding rows given an array of chamber positions
 * @param {object} rowKeyValues
 * @param {object} chambersKeyValues - The object containing the properties we want to update in the particular row
 * @param {object} state - The current chamber bed state
 * @param {[object]} chamberCoordinatesArray - an array of chambers to be modified
 * @param actualRow {number |  null}
 * @param actualCol {number |  null}
 * @param {boolean} autofill - Flag to trigger row autofill action(i.e. all chambers will be enabled)
 * @param {boolean} autoEmpty - Flag to trigger row autoEmpty action(i.e. all chambers will be disabled)
 * @returns {[object]} chamberRows
 */
function updateChamberRowByArray(
  rowKeyValues,
  chambersKeyValues,
  state,
  chamberCoordinatesArray,
  actualRow = null,
  actualCol = null,
  autofill,
  autoEmpty
) {
  try {
    return state
      .chamberRows
      .slice()
      .map(( chamberRow, i ) => {
        let newChamberRow = chamberRow.clone();
        chamberCoordinatesArray
          .forEach(coordinates => {
            if (coordinates.row === i) {
              if (chambersKeyValues.chamberMeta) {
                newChamberRow.modifyChamberMeta(
                  chambersKeyValues,
                  coordinates.col
                );
              } else if (chambersKeyValues.isIsolatorArray) {
                newChamberRow.modifyChamberIsolatorMeta(
                  chambersKeyValues,
                  coordinates.col
                );
              } else if (chambersKeyValues.isVoidArray) {
                newChamberRow.modifyChamberVoidMeta(
                  chambersKeyValues,
                  coordinates.col
                );
              } else if (chambersKeyValues.isManifoldConnectedArray) {
                newChamberRow.modifyChamberManifoldConnectedArrayMeta(
                  chambersKeyValues,
                  coordinates.col
                );
              } else if (chambersKeyValues.isOppositeStubAttached) {
                newChamberRow.modifyChamberManifoldOppositeStubMeta(
                  chambersKeyValues,
                  coordinates.col
                );
              } else {
                newChamberRow.modifyChamber(
                  chambersKeyValues,
                  coordinates.col
                );
              }

              Object.assign(newChamberRow, rowKeyValues);
              newChamberRow.autoAddEndcaps(getRequiredChamberSlotsForTwoEndcaps(
                newChamberRow.endCapWidth,
                newChamberRow.chamberWidth
              ));

              const thisChamber = newChamberRow.chambers[coordinates.col];
              if (thisChamber && typeof chambersKeyValues.accessory === "undefined" && !chambersKeyValues.isManifoldConnectedArray) {
                const manifoldIds = newChamberRow.chambers.filter(c =>
                  ( c.upperCapAccessory && c.upperCapAccessory.id === INLET_MANIFOLD_ID && c.upperCapAccessory.manifoldId ) ||
                  ( c.lowerCapAccessory && c.lowerCapAccessory.id === INLET_MANIFOLD_ID && c.lowerCapAccessory.manifoldId )
                ).map(c => {
                  return {
                    manifoldId: c.upperCapAccessory && c.upperCapAccessory.manifoldId
                      ? c.upperCapAccessory.manifoldId
                      : c.lowerCapAccessory.manifoldId,
                    col: c.col
                  };
                });

                manifoldIds.forEach(mId => {
                  const manifoldId = mId.manifoldId;
                  //const manifold = ManifoldSelectors.getManifoldByIdFromMain(mId);
                  const mIdNdx = thisChamber.isIsolatorArray.indexOf(manifoldId);
                  if (!thisChamber.active) {
                    if (mIdNdx > -1) {
                      newChamberRow.resetChambersIsolatorArray(manifoldId, coordinates.col);
                      const increment = mId.col < coordinates.col ? 1 : -1;
                      let nextChamber = newChamberRow.chambers[coordinates.col + increment];
                      while (nextChamber) {
                        if (nextChamber.isIsolatorArray.find(isoArrEntry => isoArrEntry === manifoldId)) {
                          newChamberRow.resetChambersIsolatorArray(manifoldId, nextChamber.col);
                        }
                        nextChamber = newChamberRow.chambers[nextChamber.col + increment];
                      }
                    }
                  } else if (mIdNdx === -1) {
                    if (ChamberRowService.isUnbrokenInBetween(newChamberRow, coordinates.col, mId.col)
                      && newChamberRow.chambers[mId.col].isIsolatorArray.indexOf(manifoldId) > -1) {
                      newChamberRow.modifyChamberIsolatorMeta({ isIsolatorArray: { manifoldId: manifoldId } }, coordinates.col);
                      const increment = mId.col < coordinates.col ? -1 : 1;
                      let nextChamber = newChamberRow.chambers[coordinates.col + increment];
                      while (nextChamber && nextChamber.active) {
                        if (!nextChamber.isIsolatorArray.find(isoArrEntry => isoArrEntry === manifoldId)) {
                          newChamberRow.modifyChamberIsolatorMeta({ isIsolatorArray: { manifoldId: manifoldId } }, nextChamber.col);
                        }
                        nextChamber = newChamberRow.chambers[nextChamber.col + increment];
                      }
                    }
                  }
                });
              }
            }
          });
        return newChamberRow;
      });
  } catch (exception) {
    console.error(`chamber-bed-reducer updateChamberRowByArray() :: ${exception.message}`);
  }
}

/**
 * Clean all chambers in a row meta by coordinates
 * @param manifoldId {string}
 * @param state  {object}
 * @param actualRow {number |  null}
 * @param actualCol {number |  null}
 * @returns {*}
 */
function cleanChamberRowMetaByArray(
  manifoldId,
  state,
  actualRow = null,
  actualCol = null
) {
  try {
    return state
      .chamberRows
      .slice()
      .map(chamberRow => {
        let newChamberRow = chamberRow.clone();
        if (manifoldId && actualCol !== null) {
          newChamberRow.resetChambersMetadata(
            manifoldId,
            actualCol
          );
        }
        return newChamberRow;
      });
  } catch (exception) {
    console.error(`chamber-bed-reducer cleanChamberRowMetaByArray() :: ${exception.message}`);
  }
}

function cleanChamberRowIsolatorArray(
  manifoldId,
  state,
  actualRow = null,
  actualCol = null
) {
  try {
    return state
      .chamberRows
      .slice()
      .map(( chamberRow, i ) => {
        let newChamberRow = chamberRow.clone();
        if (manifoldId && chamberRow.row === actualRow) {
          chamberRow._chambers.forEach(ch => {
            newChamberRow.resetChambersIsolatorArray(
              manifoldId,
              ch._col
            );
          });
        }
        return newChamberRow;
      });
  } catch (exception) {
    console.error(`chamber-bed-reducer cleanChamberRowIsolatorArray() :: ${exception.message}`);
  }
}

function cleanChamberRowManifoldVoidArray(
  manifoldId,
  state,
  actualRow = null,
  actualCol = null
) {
  try {
    return state
      .chamberRows
      .slice()
      .map(( chamberRow, i ) => {
        let newChamberRow = chamberRow.clone();
        if (manifoldId) {
          chamberRow
            ._chambers
            .forEach(ch => {
              newChamberRow.resetChambersVoidArray(
                manifoldId,
                ch._col
              );
            });
        }
        return newChamberRow;
      });
  } catch (exception) {
    console.error(`chamber-bed-reducer cleanChamberRowIsolatorArray() :: ${exception.message}`);
  }
}

function cleanChambersManifoldConnectedArray(
  manifoldId,
  state,
  actualRow = null,
  actualCol = null
) {
  try {
    return state
      .chamberRows
      .slice()
      .map(( chamberRow, i ) => {
        let newChamberRow = chamberRow.clone();
        if (manifoldId) {
          chamberRow
            ._chambers
            .forEach(ch => {
              newChamberRow.resetChambersManifoldConnectedArray(
                manifoldId,
                ch._col
              );
            });
        }
        return newChamberRow;
      });
  } catch (exception) {
    console.error(`chamber-bed-reducer cleanChambersManifoldConnectedArray() :: ${exception.message}`);
  }
}

/**
 * Set all row chambers values
 * @param keyValues {Object} - The object containing the properties we want to update in all row's chambers.
 * @param state {Object} - The current chamber bed state.
 * @param  row {number} - The row of the desired chamber.
 * @returns {[object]} chamberRows
 */
function setAllRowChambersValues( keyValues, state, row ) {
  // clone chamber rows array
  let chamberRows = updateChamberRow({}, {}, state, -1, -1, false, false);
  // switch all chamber key values on that row
  let chamberRow = chamberRows[row];
  // for all chambers modify
  for (let i = 0; i < state.numOfChambers; i++) {
    chamberRow.modifyChamber(keyValues, i);
  }
  // return new copy of chamber row array
  return chamberRows;
}

/**
 * Add chamber
 * @param {Object} state - The current chamber bed state.
 * @param {number} row - The row of the chamber to remove
 * @param {number} col - The column of the chamber to be removed.
 * @returns {[object]} chamberRows
 */
function addChamber( state, row, col ) {
  /* if tool command is out of bounds, return same state, otherwise return a new instance */
  if (
    row < 0 ||
    row >= state.numOfRows ||
    col < 0 ||
    col > state.numOfChambers
  ) {
    return state.chamberRows;
  } else {
    return updateChamberRow(
      {},
      { active: true },
      state,
      row,
      col,
      false,
      false
    );
  }
}

/**
 * Remove chamber
 * @param {Object} state - The current chamber bed state.
 * @returns {Array<>} chamberRow
 */
function removeChamber( state ) {
  /* remove the current selected chamber */
  return updateChamberRow(
    {},
    { active: false },
    state,
    state.selectedChamberRow,
    state.selectedChamberCol,
    false,
    false
  );
}

/**
 * This function selects the next active chamber in the provided direction.
 * @example
 * If LEFT is provided, it will select the next active
 * chamber to the left.
 *
 * @param {Object} direction - The direction of the chamber to be selected relative to the current selected chamber
 * @param {Object} state - The current chamber bed state
 * @returns {{selectedChamberRow: number, selectedChamberCol: number} - return the selected indices
 */
function selectNextChamberInDirection( direction, state ) {
  /* the loop displacement variables */
  let displacement = 0;
  /* the next active finder loop */
  if (direction === UP || direction === DOWN) {
    // assign directions
    displacement = direction === UP ? -1 : 1;
    // update the cursor to next
    let cursor = state.selectedChamberRow + displacement;
    // find horizontal active chamber
    while (cursor >= 0 && cursor < state.numOfRows) {
      // get the row
      let row = state.chamberRows[cursor];
      // if this chamber is active set the indices and break
      if (row.chambers[state.selectedChamberCol].active) {
        return {
          selectedChamberRow: cursor,
          selectedChamberCol: state.selectedChamberCol
        };
      }
      // update cursor
      cursor += displacement;
    }
  } else if (direction === LEFT || direction === RIGHT) {
    // assign directions
    displacement = direction === LEFT ? -1 : 1;
    // update the cursor to next
    let cursor = state.selectedChamberCol + displacement;
    // get the row
    let row = state.chamberRows[state.selectedChamberRow];
    // find vertical active chamber
    while (cursor >= 0 && cursor < state.numOfChambers) {
      // if this chamber is active set the indices and break
      if (row.chambers[cursor].active) {
        return {
          selectedChamberRow: state.selectedChamberRow,
          selectedChamberCol: cursor
        };
      }
      // update cursor
      cursor += displacement;
    }
  }
  return {
    selectedChamberRow: initialState.selectedChamberRow,
    selectedChamberCol: initialState.selectedChamberCol
  };
}

/**
 * Switch all end cap status (add or remove endcaps)
 * @param {Object} state - The current chamber bed state.
 * @param {boolean} active - The boolean value to switch state(active or inactive)
 * @param {number} requiredChamberSlotsForTwoEndcaps - The required in-between empty chamber slots to allocate 2 endcaps.
 *                                                     For example, one empty slots is not enough to allocate 2 MC-4500 endcaps.
 */
function switchAllEndCapStatus(
  state,
  active,
  requiredChamberSlotsForTwoEndcaps
) {
  /* make a copy of the chamber matrix with a copy of each row */
  return state.chamberRows.slice().map(( chamberRow, i ) => {
    // clone the chamber row object
    let newChamberRow = chamberRow.clone();
    // if deserialized without functions
    if (!chamberRow.clone) {
      newChamberRow = Object.assign(new ChamberRowClass(), chamberRow);
    } else {
      newChamberRow = chamberRow.clone();
    }

    //
    if (active) {
      // automatic add endcaps to row's chambers
      newChamberRow.autoAddEndcaps(requiredChamberSlotsForTwoEndcaps);
    } else {
      // automatic remove endcaps from row's chambers
      newChamberRow.autoRemoveEndcaps();
    }
    return newChamberRow;
  });
}

/**
 * Fix chamber rows deserialization utility function
 * @param {*} chamberRows
 */
function fixChamberRowsDeserialization( chamberRows ) {
  if (chamberRows.length && chamberRows[0].clone) {
    return;
  }

  // make a copy of the chamber matrix with a copy of each row
  chamberRows.forEach(( chamberRow, rowIndex ) => {
    let newChamberRow = Object.assign(new ChamberRowClass(), chamberRow);
    newChamberRow.row = rowIndex;
    let chambers = newChamberRow.chambers;
    for (let i = 0; i < chambers.length; i++) {
      chambers[i] = Object.assign(new chamberClass(), chambers[i]);
      chambers[i].row = rowIndex;
    }
    chamberRows[rowIndex] = newChamberRow;
  });
}

/**
 * Checks if this chamber bed has corner outlets.
 * @param rows {array}
 * @returns {boolean}
 */
function bedHasCornerOutlet( rows ) {
  let firstRow = null,
    lastRow = null;
  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];
    // if the row is active
    if (row.getActiveCount() > 0) {
      // if first row is null, assign this one
      if (firstRow === null) {
        firstRow = row;
      }
      // last row is always the last active seen
      lastRow = row;
    }
  }
  // the has corner outlet manifold flag
  let hasCornerOutlet = false;
  // if first row is not null, check if has corner outlet
  if (firstRow !== null) hasCornerOutlet = firstRow.hasCornerOutlet();
  // if last row is not null, check if has corner outlet
  if (firstRow !== null) hasCornerOutlet = lastRow.hasCornerOutlet() || hasCornerOutlet;
  // return the outlet
  return hasCornerOutlet;
}

/**
 * Chamber Bed reducer
 * @param state
 * @param action
 * @returns {*} state
 */
export const ChamberBedReducer = ( state = initialState, action ) => {
  let rows, cornerOutletPresent;

  switch (action.type) {
    case CHAMBER_SET_CENTRALICED_COORDINATES:
      /* mutate the initial state using computed height and width */
      initialState.x = action.payload.x;
      initialState.y = action.payload.y;
      /* move bed to centralized position */
      return {
        ...state,
        x: action.payload.x,
        y: action.payload.y
      };

    case CHAMBER_BED_MOVED:
      return {
        ...state,
        x: action.payload.x,
        y: action.payload.y
      };

    case CHAMBER_BED_TRANSFORMED:
      return {
        ...state,
        ...action.payload
      };

    case CHAMBER_BED_CHAMBER_ROWS_REBUILD:
      return {
        ...state,
        chamberRows: action.payload.chamberRows /* payload already a clone */,
        numOfRows: action.payload.numOfRows,
        numOfChambers: action.payload.numOfChambers
      };

    case CHAMBER_BED_CLEAN:
      return {
        ...state,
        isDirty: false
      };

    case CHAMBER_ACTIVATE:
      return {
        ...state,
        isDirty: true,
        chamberRows: updateChamberRow(
          {},
          { active: true },
          state,
          action.payload.row,
          action.payload.col,
          false,
          false
        )
      };

    case CHAMBERS_ACTIVATE:
      return {
        ...state,
        isDirty: true,
        chamberRows: updateChamberRowByArray(
          {},
          { active: true },
          state,
          action.payload.chamberCoordinatesArray,
          false,
          false
        )
      };

    case CHAMBERS_META_CLEAN:
      return {
        ...state,
        isDirty: true,
        chamberRows: cleanChamberRowMetaByArray(
          action.payload.manifoldId,
          state,
          action.payload.actualRow,
          action.payload.actualCol
        )
      };

    case CHAMBERS_META_UPDATE:
      return {
        ...state,
        isDirty: true,
        chamberRows: updateChamberRowByArray(
          {},
          action.payload.chamberKeyValues,
          state,
          action.payload.chamberCoordinatesArray,
          action.payload.actualRow,
          action.payload.actualCol,
          false,
          false
        )
      };

    case CHAMBERS_ISOLATOR_CLEAN:
      return {
        ...state,
        isDirty: true,
        chamberRows: cleanChamberRowIsolatorArray(
          action.payload.manifoldId,
          state,
          action.payload.actualRow,
          action.payload.actualCol
        )
      };

    case CHAMBERS_ISOLATOR_UPDATE:
      return {
        ...state,
        isDirty: true,
        chamberRows: updateChamberRowByArray(
          {},
          action.payload.chamberKeyValues,
          state,
          action.payload.chamberCoordinatesArray,
          action.payload.actualRow,
          action.payload.actualCol,
          false,
          false
        )
      };

    case CHAMBERS_MANIFOLD_META_UPDATE:
      return {
        ...state,
        isDirty: true,
        chamberRows: updateChamberRowByArray(
          {},
          action.payload.chamberKeyValues,
          state,
          action.payload.chamberCoordinatesArray,
          action.payload.actualRow,
          action.payload.actualCol,
          false,
          false
        )
      };

    case CHAMBERS_MANIFOLD_VOID_CLEAN:
      return {
        ...state,
        isDirty: true,
        chamberRows: cleanChamberRowManifoldVoidArray(
          action.payload.manifoldId,
          state,
          action.payload.actualRow,
          action.payload.actualCol
        )
      };

    case CHAMBERS_MANIFOLD_MAIN_ROW_CLEAN:
      return {
        ...state,
        isDirty: true,
        chamberRows: cleanChambersManifoldConnectedArray(
          action.payload.manifoldId,
          state,
          action.payload.actualRow,
          action.payload.actualCol
        )
      };

    case CHAMBER_DEACTIVATE:
      return {
        ...state,
        isDirty: true,
        chamberRows: updateChamberRow(
          {},
          { active: false },
          state,
          action.payload.row,
          action.payload.col,
          false,
          false
        )
      };

    case CHAMBERS_DEACTIVATE:
      return {
        ...state,
        isDirty: true,
        chamberRows: updateChamberRowByArray(
          {},
          { active: false },
          state,
          action.payload.chamberCoordinatesArray,
          false,
          false
        )
      };

    case CHAMBER_SET_ACCESORY:
      return {
        ...state,
        isDirty: true,
        chamberRows: updateChamberRow(
          {},
          { accessory: action.payload.accessory },
          state,
          action.payload.row,
          action.payload.col,
          false,
          false
        )
      };

    case CHAMBER_SET_KEY_VALUE:
      return {
        ...state,
        isDirty: true,
        chamberRows: updateChamberRow(
          {},
          action.payload.keyValueObject,
          state,
          action.payload.row,
          action.payload.col,
          false,
          false
        )
      };

    case CHAMBER_SET_UPPER_CAP_ACCESORY:
      /* update the chamber rows */
      rows = updateChamberRow(
        {},
        { upperCapActive: true, upperCapAccessory: action.payload.accessory },
        state,
        action.payload.row,
        action.payload.col,
        false,
        false
      );

      /* check if has corner outlets */
      cornerOutletPresent = bedHasCornerOutlet(rows);
      /* return state */
      return {
        ...state,
        isDirty: true,
        chamberRows: rows,
        hasCornerOutlet: cornerOutletPresent
      };

    case CHAMBER_SET_LOWER_CAP_ACCESORY:
      /* update the chamber rows */
      rows = updateChamberRow(
        {},
        { lowerCapActive: true, lowerCapAccessory: action.payload.accessory },
        state,
        action.payload.row,
        action.payload.col,
        false,
        false
      );

      /* check if has corner outlets */
      cornerOutletPresent = bedHasCornerOutlet(rows);
      /* return state */
      return {
        ...state,
        isDirty: true,
        chamberRows: rows,
        hasCornerOutlet: cornerOutletPresent
      };

    case CHAMBER_SET_SELECTED:
      return {
        ...state,
        selectedChamberRow: action.payload.row,
        selectedChamberCol: action.payload.col
      };

    case CHAMBER_RESET_SELECTED:
      return {
        ...state,
        selectedChamberRow: initialState.selectedChamberRow,
        selectedChamberCol: initialState.selectedChamberCol
      };

    case DRAWINGTOOLBAR_CHANBERS_AUTOFILL:
      return {
        ...state,
        isDirty: true,
        chamberRows: updateChamberRow({}, {}, state, null, null, true, false)
      };

    case DRAWINGTOOLBAR_CHANBERS_AUTOEMTPY:
      return {
        ...state,
        isDirty: true,
        chamberRows: updateChamberRow({}, {}, state, null, null, false, true)
      };

    case DRAWINGTOOLBAR_ENDCAPS_AUTOADD:
      return {
        ...state,
        isDirty: true,
        chamberRows: switchAllEndCapStatus(
          state,
          true,
          action.payload.requiredChamberSlotsforTwoEndcaps
        )
      };

    case CHAMBER_ADD_LEFT:
      // NOTE: I'm keeping these cases separated in the event of a future change
      // with the add-remove tool, don't refactor as fall cascade
      return {
        ...state,
        isDirty: true,
        chamberRows: addChamber(state, action.payload.row, action.payload.col)
      };

    case CHAMBER_ADD_TOP:
      return {
        ...state,
        isDirty: true,
        chamberRows: addChamber(state, action.payload.row, action.payload.col)
      };

    case CHAMBER_ADD_RIGHT:
      return {
        ...state,
        isDirty: true,
        chamberRows: addChamber(state, action.payload.row, action.payload.col)
      };

    case CHAMBER_ADD_DOWN:
      return {
        ...state,
        isDirty: true,
        chamberRows: addChamber(state, action.payload.row, action.payload.col)
      };

    case CHAMBER_ADD_ROW:
      return {
        ...state,
        isDirty: true,
        chamberRows: setAllRowChambersValues(
          { active: true },
          state,
          action.payload.row
        )
      };

    case CHAMBER_REMOVE_LEFT:
      return {
        ...state,
        isDirty: true,
        ...selectNextChamberInDirection(DOWN, state),
        chamberRows: removeChamber(state)
      };

    case CHAMBER_REMOVE_TOP:
      return {
        ...state,
        isDirty: true,
        ...selectNextChamberInDirection(LEFT, state),
        chamberRows: removeChamber(state)
      };

    case CHAMBER_REMOVE_RIGHT:
      return {
        ...state,
        isDirty: true,
        ...selectNextChamberInDirection(UP, state),
        chamberRows: removeChamber(state)
      };

    case CHAMBER_REMOVE_DOWN:
      return {
        ...state,
        isDirty: true,
        ...selectNextChamberInDirection(RIGHT, state),
        chamberRows: removeChamber(state)
      };

    case CHAMBER_REMOVE_ROW:
      return {
        ...state,
        isDirty: true,
        chamberRows: setAllRowChambersValues(
          { active: false },
          state,
          action.payload.row
        )
      };

    case CHAMBER_ROW_SET_OFFSET:
      return {
        ...state,
        isDirty: true,
        chamberRows: updateChamberRow(
          {
            offSet: action.payload.offSet,
            pixelOffSet: action.payload.pixelOffSet
          },
          {},
          state,
          action.payload.row,
          null,
          false,
          false
        )
      };

    case CALCULATIONS_VOLUME_OPTIMIZED:
      return {
        ...state,
        chamberRows: action.payload.chamberRows
      };

    case MULTIBED_RESET_APP_STATE:
      return {
        ...initialState
        // scaleX: state.scaleX,
        // scaleY: state.scaleY
      };

    case SHOW_INSERTA_TEE_WARNING:
      return {
        ...state,
        insertaTeeWarning: action.payload.value
      };

    case SHOW_INSERTA_TEE_WARNING_TYPE:
      return {
        ...state,
        insertaTeeWarningType: action.payload.value
      };

    case SHOW_INSERTA_TEE_VALUES:
      return {
        ...state,
        insertaTeeValues: {
          col: action.payload.col,
          row: action.payload.row,
          chamberAccessory: action.payload.chamberAccessory
        }
      };

    case SHOW_FEED_CONNECTOR_VALUES:
      return {
        ...state,
        feedConnectorValues: {
          col: action.payload.col,
          row: action.payload.row,
          chamberAccessory: action.payload.chamberAccessory
        }
      };

    case IMPERVIOUS_LINER:
      return {
        ...state,
        imperviousLiner: action.payload
      };

    case NUMBER_OF_FEED_CONNECTORS:
      return {
        ...state,
        feedConnectors: {
          numberOfFeedConnectors: action.payload.numberOfFeedConnectors,
          numberOfRemovedFeedConnectors: action.payload.numberOfRemovedFeedConnectors
        }
      };

    case POSITION_OF_INSPECTION_PORT:
      return {
        ...state,
        positionOfInspectionPort: {
          col: action.payload.col,
          row: action.payload.row
        }
      };

    case APPTOOLBAR_BASIC_RESET_APP_STATE:
    case APPTOOLBAR_RESET_APP_STATE:
      return initialState;

    case SUB_PROJECTS_CRUD_RESTORE_STATE:
    case PROJECTS_CRUD_RESTORE_STATE:
      /* receive the new state */
      let rState = action.payload.chamberbed;
      /* check if the current new state has deserialized
      plain chamber row objects and chambers */

      fixChamberRowsDeserialization(rState.chamberRows);

      /* todo transformation logic here */
      return {
        ...rState
      };

    default:
      return state;
  }
};

// SELECTORS
const getChamberbed = ( state ) => state.chamberbed;
const ChamberBedSelectors = {
  // Checks if there is any active chambers on bed
  hasAnyActiveChambers: () => {
    const getActiveChambers = createSelector(
      [getChamberbed],
      ( chamberbed ) => {
        let hasAnyActive = false;
        chamberbed.chamberRows.forEach(row => {
          row._chambers.forEach(chamber => {
            if (chamber._active) hasAnyActive = true;
          });
        });
        return hasAnyActive;
      }
    );
    return getActiveChambers(getStore().getState());
  }
};
export default ChamberBedSelectors;



// WEBPACK FOOTER //
// ./src/reducers/chamber-bed-reducer.js